(() => {
  const config = document.getElementById('OlouiooTableStylingData');
  if (!config) return;
  const assets = JSON.parse(config.textContent);
  const template = assets.template;
  const scope = document.querySelector('.product-information');
  if (!scope) return;
  const selected = name => scope.querySelector(`[data-table-property="${name}"]:checked`)?.value.toLowerCase().replaceAll(' ','-');
  const source = original => {
    const scene = original?.match(/la-table-(ivory|white|deep-green|burgundy)-cloth-(ivory|white|deep-green|burgundy)-florals/)
      || original?.match(/olouioo-style-(ivory|white|deep-green|burgundy)-(ivory|white|deep-green|burgundy)-crystal-/);
    if (!scene || !template) return original;
    const colour = group => scope.querySelector(`[data-table-colour="${group}"]:checked`)?.value.toLowerCase().replaceAll(' ','-');
    const cloth = colour(1) || scene[1];
    const florals = colour(2) || scene[2];
    return template.replace('olouioo-style-ivory-ivory-crystal-white.webp',`olouioo-style-${cloth}-${florals}-crystal-${selected('Napkin colour') || 'white'}.webp`);
  };
  const layerSource = () => assets.plateLayers?.[scope.querySelector('[data-plate-style-id]:checked')?.dataset.plateStyleId] || '';
  const furnitureSelected = () => scope.querySelector('[data-table-furniture]:checked')?.value === 'Yes';
  const updateFurniture = target => {
    if(!target || !assets.chairs)return;
    const selected=furnitureSelected();
    target.classList.toggle('omf-with-furniture',selected);
    target.omfPlateLayer?.classList.toggle('omf-with-furniture',selected);
    let layer=target.omfFurnitureLayer;
    if(selected && (!layer || !layer.isConnected)) {
      layer=document.createElement('span');layer.className='omf-furniture-detail';
      const figure=document.createElement('span'),photo=document.createElement('img'),caption=document.createElement('span'),title=document.createElement('strong'),colour=document.createElement('small');
      figure.className='omf-furniture-card';caption.className='omf-furniture-caption';
      photo.src=assets.chairs;photo.alt=assets.chairLabel;photo.width=160;photo.height=160;photo.decoding='async';
      title.textContent=assets.chairCaption;colour.textContent=assets.chairColour;
      caption.append(title,colour);figure.append(photo,caption);layer.append(figure);
      target.after(layer);target.omfFurnitureLayer=layer;
    }
    if(layer) {
      layer.hidden=!selected;
      layer.style.transform=target.style.transform;
    }
  };
  const updatePlateLayer = target => {
    if(!target) return;
    let layer=target.omfPlateLayer;
    if(!layer || !layer.isConnected) {
      layer=document.createElement('img');layer.className='omf-plate-layer';layer.alt='';layer.setAttribute('aria-hidden','true');layer.width=1000;layer.height=847;target.after(layer);target.omfPlateLayer=layer;
    }
    const url=layerSource();layer.hidden=!url;
    if(url && layer.getAttribute('src')!==url) layer.src=url;
    layer.style.transform=target.style.transform;
    updateFurniture(target);
  };
  window.OlouiooTableStyling = {source,layerSource,updatePlateLayer};
  const init = () => {
    const gallery = scope.querySelector('.product-information__media');
    const main = document.querySelector('.omf-image-button > img.omf-image');
    if (!gallery || !main) return;
    let target, layer, request = 0, requested = '';
    const update = () => {
      updatePlateLayer(main);
      const modal=document.querySelector('.omf-lightbox-stage > img:not(.omf-plate-layer)');
      updatePlateLayer(modal);
      if (matchMedia('(max-width:749px)').matches) return;
      const candidate = gallery.querySelector('.product-media__image > img:not(.omf-gallery-style-layer):not(.omf-plate-layer)');
      if (!candidate) return;
      if(candidate !== target) {
        layer?.remove(); target = candidate; requested = ''; ++request;
        layer = document.createElement('img');
        layer.className = 'omf-gallery-style-layer'; layer.alt = ''; layer.setAttribute('aria-hidden','true');
        layer.width = 1000; layer.height = 847;
        candidate.after(layer);
      }
      if(!candidate.parentElement.classList.contains('otv-gallery-stage'))candidate.parentElement.classList.add('otv-gallery-stage');
      updatePlateLayer(target);
      layer.classList.toggle('omf-with-furniture',furnitureSelected());
      const overlays=[layer,target.omfPlateLayer,target.omfFurnitureLayer].filter(Boolean);
      const current=[...candidate.parentElement.children].slice(-overlays.length);
      if(overlays.some((overlay,index)=>current[index]!==overlay))candidate.parentElement.append(...overlays);
      const url = source(target.src);
      if (url === requested) return;
      requested = url;
      const version = ++request;
      const incoming = new Image();
      incoming.onload = async () => {
        await incoming.decode?.().catch(() => {});
        if(version !== request) return;
        layer.src = url;
        layer.dataset.selection = `Clear crystal / ${selected('Napkin colour')}`;
      };
      incoming.onerror = () => { if(version === request) requested = ''; };
      incoming.src = url;
    };
    new MutationObserver(() => updatePlateLayer(main)).observe(main,{attributes:true,attributeFilter:['src','style']});
    new MutationObserver(update).observe(gallery,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','class']});
    scope.addEventListener('olouioo:table-details',update);
    scope.addEventListener('variant:update',update);
    scope.addEventListener('change',event=>{if(event.target.matches('[data-table-furniture]'))update();});
    matchMedia('(max-width:749px)').addEventListener('change',update);
    gallery.addEventListener('click',event => {
      if(!event.target.closest('.product-media__image')) return;
      event.preventDefault(); event.stopPropagation(); main.closest('button').click();
    },true);
    const modalImage=document.querySelector('.omf-lightbox > img');
    if(modalImage) {const stage=document.createElement('div');stage.className='omf-lightbox-stage';modalImage.before(stage);stage.append(modalImage);updatePlateLayer(modalImage);}
    update();
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();



